module.exports = __webpack_public_path__ + "static/media/stamp_icon.419f66a2.svg";